// @flow

import _ from 'lodash';

import type { AppPermissionState, AppPermissionAction } from 'stores/flow-type/app-permission.type';

import {
  UPDATE_SCOPES_REQUEST,
  UPDATE_SCOPES_SUCCESS,
  UPDATE_SCOPES_FAILURE,
  GET_PERMISSION_LINK_REQUEST,
  GET_PERMISSION_LINK_SUCCESS,
  GET_PERMISSION_LINK_FAILURE
} from 'stores/flow-type/app-permission.type';

const initialState: AppPermissionState = {
  loading: false,
  permissionLinkGetting: false,
  permissionLink: null,
  success: false,
  error: undefined,
  accessScopes: {}
};

const appPermissionReducers = (
  state: AppPermissionState = initialState,
  action: AppPermissionAction
) => {
  switch (action.type) {
    case UPDATE_SCOPES_REQUEST:
      return { ...state, loading: true };
    case UPDATE_SCOPES_SUCCESS: {
      const { data } = action.payload;
      const accessScopes = _.get(data, 'accessScopes', {});

      return {
        ...state,
        loading: false,
        success: true,
        error: undefined,
        accessScopes
      };
    }
    case UPDATE_SCOPES_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };
    case GET_PERMISSION_LINK_REQUEST:
      return { ...state, permissionLinkGetting: true };
    case GET_PERMISSION_LINK_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        permissionLinkGetting: false,
        success: true,
        error: undefined,
        permissionLink: data.authURL,
      };
    }
    case GET_PERMISSION_LINK_FAILURE:
      return {
        ...state,
        permissionLinkGetting: false,
        success: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default appPermissionReducers;
